import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { ReactComponent as Deposit } from "../../assets/icons/deposit.svg";
import { ReactComponent as Withdraw } from "../../assets/icons/withdraw.svg";
import { ReactComponent as Arrow } from "../../assets/icons/solid_interface_caret_down.svg";
import { ReactComponent as TopArraw } from "../../assets/icons/top-arrow.svg";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { toToman } from "../../utils/Utils";

function FilterInfoBox({ data }) {
  const [expanded, setExpanded] = useState("panel1");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <Accordion
        sx={{
          borderRadius: `10px !important`,
          boxShadow: `0px 2px 4px 1px #d9d7d6`,
        }}
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary
          expandIcon={<Arrow />}
          icon={<TopArraw />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          sx={{
            minHeight: "30px",
            "&.Mui-expanded": {
              minHeight: "30px",
            },
            "& .Mui-expanded": {
              margin: "5px 0 !important",
            },
          }}
        >
          <Typography variant="h5" sx={{ flexShrink: 0, fontSize: "12px" }}>
            فیلترشده :&nbsp;{data?.transactions?.totalElements}&nbsp;تراکنش
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                flexGrow: "1",
                borderRight: (theme) => `1px solid ${theme.palette.grey[6]}`,
              }}
            >
              <Deposit width={24} height={24} />

              <Typography mt={1} variant="subtitle1" color="#797979">
                واریز (تومان)
              </Typography>
              <Typography mt={0.5} variant="h5" fontSize={12} color={"#797979"}>
                {toToman(data.totalCredit)}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                flexGrow: "1",
              }}
            >
              <Withdraw width={24} height={24} />
              <Typography mt={1} variant="subtitle1" color={"#797979"}>
                برداشت (تومان)
              </Typography>
              <Typography mt={0.5} variant="h5" fontSize={12} color={"#797979"}>
                {toToman(data.totalDebit)}
              </Typography>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </>
  );
}

export default FilterInfoBox;
